import React, { Component } from "react";
import { connect } from "react-redux";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import HomeCard from "./HomeCard";
import {
    nonClaimsModules,
} from "../../constants/SMEModulesToMatchOn";
import { ButtonConfig } from "../../constants/Constants";
import ErrorImage from "../../assets/img/contact-us/Contact-Us-Leaver-Banner_544x238.png";
import Button from "./../shared/buttons/Button";
import ShadowedContainerSME from "../shared/containers/ShadowedContainerSME";
import style from "../../assets/css/modules/contact-us/contact-us.css";
import { Urls } from "../../constants/UrlConstants";

export class LapseCard extends Component {
    static content = Store.Home;
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    GetMatchedImage(matches, imgSrcMobile, imgSrc) {
        return matches ? (
            <img src={imgSrcMobile} alt="" aria-hidden />
        ) : (
            <img src={imgSrc} alt="" aria-hidden />
        );
    }
    onButtonClick(uri) {
        window.open(uri);
      }
    onSubmit() {
        window.open(Urls.RequestCallBack, "_blank", "noreferrer");
      }
    render() {
        return (
            <div className="row">
                <div className= "col-sm-12 col-lg-4"  
                    data-access-health-support-home-card>
                    <Content
                        names={[
                            Store.Home.Cards.HomeEAPpolicySrc.IconSrc,
                            Store.Home.Cards.HomeEAPpolicySrc.Heading,
                            Store.Home.Cards.HomeEAPpolicySrc.Description.Lapse,
                            Store.Home.Cards.HomeEAPpolicySrc.LinkText,
                            Store.Home.Cards.HomeEAPpolicySrc.LinkTo,
                            Store.Home.Cards.HomeEAPpolicySrc.ExternalLinkTo
                        ]}
                    >
                        {(
                            iconSrc,
                            heading,
                            description,
                            linkText,
                            linkTo,
                            externalLinkTo
                        ) => (
                            <HomeCard
                                IconSrc={iconSrc}
                                Heading={heading}
                                Description={description}
                                LinkText={linkText}
                                LinkTo={linkTo}
                                ExternalLinkTo={externalLinkTo}
                                id={ButtonConfig.HomeIndcta_mol_hp_docs}
                            />
                        )}
                    </Content>
                </div>

                <div
                    className="col-sm-12 col-lg-4"
                    data-access-health-support-home-card
                >
                    <Content
                        names={[
                            Store.Home.Cards.HomeClaimSrc.IconSrc,
                            Store.Home.Cards.HomeClaimSrc.Heading,
                            Store.Home.Cards.HomeClaimSrc.Description.Lapse,
                            Store.Home.Cards.HomeClaimSrc.LinkText,
                            Store.Home.Cards.HomeClaimSrc.LinkTo,
                            Store.Home.Cards.HomeClaimSrc.ExternalLinkTo
                        ]}
                    >
                        {(
                            iconSrc,
                            heading,
                            description,
                            linkText,
                            linkTo,
                            externalLinkTo
                        ) => (
                            <HomeCard
                                IconSrc={iconSrc}
                                Heading={heading}
                                Description={description}
                                LinkText={linkText}
                                LinkTo={
                                    this.props.isLapsed && this.props.isInternational ? null : linkTo
                                }
                                id={ButtonConfig.HomeIndcta_mol_hp_vcl}
                                ExternalLinkTo={externalLinkTo}
                            />
                        )}

                    </Content>
                </div>
                <div
                    className="col-sm-12 col-lg-4"
                    data-access-health-support-home-card
                >
                    <Content
                        names={[
                            Store.Home.Cards.HomeclaimMoneySrc.IconSrc,
                            Store.Home.Cards.HomeclaimMoneySrc.Heading,
                            Store.Home.Cards.HomeclaimMoneySrc.Description,
                            Store.Home.Cards.HomeclaimMoneySrc.LinkText,
                            Store.Home.Cards.HomeclaimMoneySrc.LinkTo,
                            Store.Home.Cards.HomeclaimMoneySrc.ExternalLinkTo
                        ]}
                    >
                        {(
                            iconSrc,
                            heading,
                            description,
                            linkText,
                            linkTo,
                            externalLinkTo
                        ) => (
                            <HomeCard
                                IconSrc={iconSrc}
                                Heading={heading}
                                Description={description}
                                LinkText={linkText}
                                LinkTo={ linkTo}
                                ExternalLinkTo={externalLinkTo}
                                id={ButtonConfig.HomeIndcta_mol_hp_cp}
                            />
                        )}

                    </Content>
                </div>
                {this.props.IsLargeCorporate || this.props.IsSME ? (
                <div className="container">
                    <div className="row">
                        <ShadowedContainerSME>
                        <div className={ "row"}> 
                        <div className="col-xl-7">
                            <div className={style.contactusLBox}>
                                <h2>
                                    <Content name={Store.ContactUs.LapsedLeaverHeader} />
                                </h2>
                                <div>
                                    <div>
                                        <Content name={ Store.ContactUs.LapsedLeaverDescription} />
                                    </div>
                                </div>
                            <div className="row">
                                <div className="col-lg-12 p-0">
                                <div style={{ textAlign: "center" }}>
                                    <Button
                                        buttonType="secondaryBlueButton"
                                        label={Store.ContactUs.CallusOn}
                                        contactUs="contactUs"
                                        ClassName="icon-phones"
                                    />
                                    <Button
                                        buttonType="primaryBlueButton"
                                        onClick={this.onSubmit}
                                        label={Store.ContactUs.RequestCallBack}
                                        contactUs="contactUs"
                                        ClassName="icon-contact"
                                    />
                                </div>
                                </div>
                            </div>
                            
                             <div className={"col-md-5 d-none d-sm-block" }>

                    <img className={style.contactLImg} src={ErrorImage} alt="" />
                  </div>  
                  </div>
                  </div>
                  </div>
                        </ShadowedContainerSME>
                    </div>
                </div>
                  ):null}
            </div>
        );
    }
}

export const mapStateToLapseCard = (state) => {
    const { IsLapsed: isLapsed, IsFormat2: isFormat2, IsSME: isSME } =
        state.policyReducer.selectedPolicy || {};
    return {
        shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
            state.policyReducer && state.policyReducer.selectedPolicy,
            nonClaimsModules
        ),
        isLapsed,
        isFormat2,
        isSME
    };
};

export default connect(
    mapStateToLapseCard
)(LapseCard);